<ng-container *ngIf="isLoaded" [formGroup]="editProductForm">
  <form [formGroup]="editProductForm" (ngSubmit)="onSubmit()">
    <nb-tabset ubsVerticalTabs>
      <!-- <nb-tabset> -->
      <nb-tab *ngFor="let fieldSet of fieldSets" [tabTitle]="fieldSet.fieldSetName">
        <ubs-ofbiz-form-group [fieldSet]="fieldSet" [ofbizForm]="ofbizForm" [fields]="fields"
          [formGroup]="childForms[fieldSet.fieldSetName]">
        </ubs-ofbiz-form-group>
      </nb-tab>
    </nb-tabset>

    <!-- <p>Shit works</p> -->
    <!-- Main submit button outside of tabs -->
    <div class="form-actions">
      <button type="submit" nbButton status="primary" [disabled]="!editProductForm.valid">
        Submit Complete Form
      </button>
    </div>
  </form>
</ng-container>